import { createContext, useState } from 'react';

const ModalContext = createContext({
  open: false,
  modal: 'none',
  modalData: {},
  openModal: () => {},
  closeModal: () => {},
  setModalData: () => {}
});

export function ModalContextProvider(props) {
  const [open, setOpen] = useState(false);
  const [modal, setModal] = useState('none');
  const [modalData, setModalData] = useState({});

  function openModalHandler(modalType, data = {}) {
    setModal(modalType);
    setModalData(data);
    setOpen(true);
  }

  function closeModalHandler() {
    setOpen(false);
    setModal('none');
    setModalData({});
  }

  const context = {
    open: open,
    modal: modal,
    modalData: modalData,
    openModal: openModalHandler,
    closeModal: closeModalHandler,
    setModalData: setModalData,
  };

  return (
    <ModalContext.Provider value={context}>
      {props.children}
    </ModalContext.Provider>
  );
}

export default ModalContext;
